import React from "react";

import {mergeClasses} from "@material-ui/styles";

import SelectFormElement from "../SelectFormElement";


const SelectFormElementV2 = props => {
  const {custom_classes, newDesign, placeholder, ...otherProps} = props;

  const classes = {inputRoot: 'newDesign', labelRoot: 'newDesign'};

  return (
    <SelectFormElement
      {...otherProps}
      custom_classes={newDesign ?
        mergeClasses({
          baseClasses: classes,
          newClasses: custom_classes,
          Component: SelectFormElementV2
        }) : custom_classes
      }
      placeholder={placeholder || 'Bitte wählen'}
    />
  )
};

export default SelectFormElementV2;